<!--  -->
<template>
    <div class="box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/jianyanService' }">检测检验服务方案</el-breadcrumb-item>
        <el-breadcrumb-item>服务方案详情</el-breadcrumb-item>
      </el-breadcrumb>

      <div style="background-color: white;display: flex;flex-direction: row;margin-top: 20px;">
        <div style="display: flex;justify-content: center;align-items: center;width: 35%;padding: 10px;">
            <img class="img" :src="downloadUrl + infoData.photo" alt="">
        </div>
        <div style="display: flex;justify-content: center;width: 50%;padding: 10px;flex-direction: column;">
            <div  style="display: flex;justify-content: center;padding: 10px;flex-direction: column;font-size: 20px;font-weight: 700;color: #333;line-height: 22px;">{{ infoData.title }}</div>
            <div  style="display: flex;justify-content: center;padding: 10px;flex-direction: column;padding-top: 24px;">
                <div style="font-size: 15px;font-weight: 400;color: #333;margin-top: 16px;">报告语言：{{ infoData.language }}</div>
                <div style="font-size: 15px;font-weight: 400;color: #333;margin-top: 16px;">报告形式：{{ infoData.type }}</div>
                <div style="font-size: 15px;font-weight: 400;color: #333;margin-top: 16px;">服务周期：{{ infoData.serviceTime }}</div>
                <div style="font-size: 15px;font-weight: 400;color: #333;margin-top: 16px;">服务提供：{{ infoData.provider }}</div>
            </div>
        </div>
      </div>
      <div class="content" style="display: flex;flex-direction: row;">
        <div class="content-box" style="width: 70%;">
            <div class="top">
                <div class="left" style="margin-left: 15px;">
                    <div class="text">
                        <div class="title">服务详情</div>
                        <div class="en-text">service scheme</div>
                    </div>
                </div>
            </div>
            <div class="list">
                <div style="height: 30px;display: flex;align-items: center;border-bottom: 1px solid #eee;width: 100%;"><img style="height: 20px;width: 20px;" src="../../assets/img/jiliangnengli/shuqian.png" alt=""><span style="margin-left: 10px;">服务内容简介</span></div>
                <div style="line-height: 1.7;margin-top: 20px;" v-html="infoData.synopsis"></div>
            </div>
            <div class="list" style="display: flex;flex-direction: column;">
                <div style="height: 30px;display: flex;align-items: center;border-bottom: 1px solid #eee;width: 100%;"><img style="height: 20px;width: 20px;" src="../../assets/img/jiliangnengli/jiagegongshi.png" alt=""><span style="margin-left: 10px;">参考价格</span></div>
                <div style="margin-top: 20px;"> {{ infoData.price }}</div>
            </div>
            <div class="list">
                <div style="height: 30px;display: flex;align-items: center;border-bottom: 1px solid #eee;width: 100%;"><img style="height: 20px;width: 20px;" src="../../assets/img/jiliangnengli/tiaoyin.png" alt=""><span style="margin-left: 10px;">服务内容清单</span></div>
                <div class="list"  v-if="infoData.inspectServiceplanDetailsList.length != undefined && infoData.inspectServiceplanDetailsList.length > 0">
                    <table class="table">
                    <thead class="table-head">
                    <tr>
                        <td style="border: 1px solid #ebeef5;">项目名称</td>
                        <td style="border: 1px solid #ebeef5;">服务依据标准</td>
                        <td style="border: 1px solid #ebeef5;">服务范围和约束</td>
                        <td style="border: 1px solid #ebeef5;">预计服务周期(工作日)</td>
                        <td style="border: 1px solid #ebeef5;">参考服务价格(元)</td>
                    </tr>
                    </thead>
                    <tbody class="table-body">
                    <tr v-for="item in infoData.inspectServiceplanDetailsList">
                    <!-- <tr v-for="item in machineList"> -->
                        <td style="border: 1px solid #ebeef5;">
                        <div class="name">{{ item.name }}</div>
                        </td>
                        <td style="border: 1px solid #ebeef5;">
                        <div class="num">{{ item.standard }}</div>
                        </td>
                        <td style="border: 1px solid #ebeef5;">
                        <div class="num">{{ item.scope }}</div>
                        </td>
                        <td style="border: 1px solid #ebeef5;">
                        <div class="num">{{ item.cycle }}</div>
                        </td>
                        <td style="border: 1px solid #ebeef5;">
                        <div class="num">{{ item.price }}</div>
                        </td>
                    </tr>
                    </tbody>
                    </table>
                </div>
                <div v-else style="width: 100%;display: flex;justify-content: center;align-items: center;">
                    <!-- <tr> -->
                        <td colspan="8">
                            <el-empty description="暂无服务内容清单"></el-empty>
                        </td>
                    <!-- </tr> -->
                </div>
            </div>
        </div>
        <div class="content-box" style="width: 28%;height: 100%;margin-left: 2%;">
            <div class="list">
                <div style="height: 30px;display: flex;align-items: center;border-bottom: 1px solid #eee;width: 100%;padding-bottom: 20px;"><span style="margin-left: 10px;">友情链接</span></div>
            </div>
            <div style="display: flex;flex-direction: column;line-height: 1.5;justify-content: center;align-items: center;margin-bottom: 20px;margin-top: -20px;">
                <a class="aStyle" target="_blank" href="http://www.zbqim.com.cn/" >检测机构</a>
                <!-- <a class="aStyle" target="_blank" href="http://zbjls.zbqim.com.cn/">计量</a> -->
                <a class="aStyle" target="_blank" href="http://sdzbzjy.zbqim.com.cn/">工业产品</a>
                <a class="aStyle" target="_blank" href="http://zbyjs.zbqim.com.cn/">食品药品</a>
                <a class="aStyle" target="_blank" href="http://zbzlpp.zbqim.com.cn/">纤维纺织制品</a>
                <a class="aStyle" target="_blank" href="http://222.173.241.90:8095/cmiims/a/login">计量公共服务平台</a>
                <a class="aStyle" target="_blank" href="http://psp.e-cqs.cn/egov/shIndex.html">强检平台</a>
            </div>
        </div>
    </div>
    </div>
  </template>
  
  <script>
  import { Server,httpurl } from "@/server";
  export default {
      data () {
          return {
              pageSize: 8,
              pageNo: 1,
              infoData:{},
              downloadUrl: '',
          }
      },
      created() {
          this.getData()
          this.downloadUrl = this.$downloadUrl
          this.infoData = this.$route.query
      },
  
      methods: {
          getData() {
              Server.getCheckServerInfoDetail({id:this.$route.query.id}).then(res => {
                  console.log(res);
                  if(res.success) {
                    this.infoData = res.result
                    console.log(this.infoData);
                  }
              })
          },
          currentPage(page) {
              this.pageNo = page;
              this.getData()
          },
          xia() {
              this.pageNo = this.pageNo + 1;
              this.getData()
          },
          shang() {
              this.pageNo = this.pageNo - 1;
              this.getData()
          },
      }
  }
  </script>
  
  <style lang="less" scoped>
      .content {
        //   width: 1100px;
          margin-top: 15px;
          .content-box {
              background-color: #fff;
              padding: 10px;
              box-sizing: border-box;
              margin-bottom: 20px;
  
              display: block;
              .top {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 15px 0;
                  border-bottom: 1px solid #ccc;
                  .left {
                      display: flex;
                      img {
                          width: 40px;
                          height: 35px;
                          margin: 0 15px;
                      }
                      .text {
                          color: #1677ff;
                          .title {
                              font-size: 24px;
                              font-weight: bold;
                          }
                          .en-text {
                              font-size: 14px;
                          }
                      }
                  }
                  .right {
                      color: #999;
                  }
              }
  
              .list {
                  margin: 30px 10px;
                  display: flex;
                  flex-wrap: wrap;
                  margin-left: 20px;
                  .item {
                      width: 22%;
                      padding: 10px;
                      box-sizing: border-box;
                      border: 1px solid #ccc;
                      margin: 20px;
                      &:nth-child(4n) {
                          margin-right: 3px;
                      }
                      &:nth-child(4n+1) {
                          margin-left: 4px;
                      }
                      .img {
                          width: 100%;
                          height: 160px;
                          padding-bottom: 20px;
                          border-bottom: 1px solid #ccc;
                      }
                      .info {
                          margin: 20px 0;
                          font-size: 14px;
                          .name {
                              display: flex;
                              .unit-icon {
                                  width: 17px;
                                  height: 20px;
                                  margin-right: 10px;
                              }
                          }
                      }
                  }
                  .list {
                    width: 100%;
                    height: 85%;
                    overflow-y: auto;
                    margin-top: 20px;
                    .table {
                        width: 100%;
                        text-align: center;
                        font-size: 15px;
                        border: none;
                
                        position: relative;
                    tr {
                        border-bottom: 1.5px solid #e3f7f7;
                        // box-shadow: 0 0 3px #c4f7f7;
                    }
                    td {
                        padding: 5px 10px;
                        vertical-align: middle!important
                    }
                    .table-head {
                        position: sticky;
                        top: 0;
                        background-color: #f9f9f9;
                        color: #333;
                        border: 1px solid #ebeef5;
                        td {
                            padding: 8px 10px;
                        }
                    }
                    .table-body {
                        border: 1px solid #ebeef5;
                        .name {
                            margin: 10px 0;
                        }
                        .num {
                            color: #333;
                        }
                        .status {
                            color: #009291;
                            cursor: pointer;
                        }
                    }
                    }
                }
              }
              .bottom {
                  display: flex;
                  justify-content: center;
                  margin-bottom: 10px;
              }
              .aStyle {
                height: 48px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                background: #f5f5f5;
                font-size: 14px;
                font-family: Source Han Sans CN, Source Han Sans CN-Medium;
                font-weight: 500;
                color: #666;
                border: 1px solid #f5f5f5;
                cursor: pointer;
                transition: all .25s;
                margin-top: 16px;
                border-radius: 2px;
                cursor: pointer;
              }
              .aStyle:hover {
                background: #f0f8ff;
                border: 1px solid #7fb5ff;
                color: #1677ff;
              }
          }
      }
  </style>
  